export default "__VITE_ASSET__DhBXVqpW__"